import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import AuthLayout from "@/components/layout/AuthLayout";
import { PasswordInput } from "@/components/common/PasswordInput";
import { FormAlert } from "@/components/common/Alert";
import { api, errorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function SignIn() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/auth/setup-status").then(({ data }) => data.needs_setup && navigate("/setup", { replace: true })).catch(() => {});
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      navigate(location.state?.from || "/", { replace: true });
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout
      title="Sign in"
      subtitle="Use your Fuse Capital work email."
      testid="signin-page"
      footer={<span>No account yet? <Link to="/request-invitation" className="font-medium text-foreground underline underline-offset-4" data-testid="request-invitation-link">Request an invitation</Link></span>}
    >
      <form onSubmit={submit} className="space-y-5" noValidate>
        <FormAlert testid="signin-error">{error}</FormAlert>
        <div className="space-y-2">
          <Label htmlFor="email">Work email</Label>
          <Input id="email" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="signin-email-input" />
        </div>
        <PasswordInput id="password" label="Password" value={password} onChange={setPassword} testid="signin-password-input" />
        <Button type="submit" className="w-full" disabled={busy || !email || !password} data-testid="signin-submit-button">
          {busy ? "Signing in" : "Sign in"}
        </Button>
        <Link to="/forgot-password" className="block text-sm text-muted-foreground underline underline-offset-4 hover:text-foreground" data-testid="forgot-password-link">
          Forgotten your password
        </Link>
      </form>
    </AuthLayout>
  );
}
